import { render, staticRenderFns } from "./sound_rule.vue?vue&type=template&id=de10de44&scoped=true"
import script from "./sound_rule.vue?vue&type=script&lang=js"
export * from "./sound_rule.vue?vue&type=script&lang=js"
import style0 from "./sound_rule.vue?vue&type=style&index=0&id=de10de44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de10de44",
  null
  
)

export default component.exports